import { ClaimFailurePart } from '@/types/asicw/claims'

/**
 * Gets the icon for a failed part.
 * @param part The failed part
 * @returns The icon name
 */
export const getFailedPartIcon = (part: ClaimFailurePart) => {
  const partIconMap = {
    [ClaimFailurePart.Hashboard]: 'material-symbols:settop-component-outline',
    [ClaimFailurePart.ControlBoard]: 'material-symbols:developer-board-outline',
    [ClaimFailurePart.PowerSupply]: 'material-symbols:power-outline',
    [ClaimFailurePart.Fan]: 'material-symbols:mode-fan-outline',
  }
  return partIconMap[part]
}
